import { createRouter, createWebHistory } from 'vue-router'

import { adminAuthGuard } from '@/composables/useAuthentication'
import { useI18nLoader } from '@/i18n'
import SiteLayout from '@/layouts/site/SiteLayout.vue'

import admin from './admin'
import auth from './auth'
import designSystem from './design-system'
import site from './site'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    ...site,
    ...auth,
    ...admin,
    ...designSystem,
    {
      path: '/',
      component: SiteLayout,
      children: [
        {
          path: '/:pathMatch(.*)*',
          name: 'not-found',
          component: () => import('@/views/site/NotFoundPage.vue'),
        },
      ],
    },
  ],

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
})

// Runs on every navigation (not a per-route beforeEnter) so role checks re-fire on in-app
// navigation between admin routes, not just on first entry into the /admin subtree.
router.beforeEach(adminAuthGuard)

// Site pages manage title via useSEO() composable (@unhead/vue).
// Admin/auth pages use meta.title via this hook.
router.afterEach((to) => {
  if (to.meta?.title) {
    document.title = `Pin Vision - ${to.meta.title}`
  }
})

router.onError((error, to) => {
  const isChunkError =
    error.message.includes('Failed to fetch dynamically imported module') ||
    error.message.includes('Importing a module script failed') ||
    error.message.includes('error loading dynamically imported module') ||
    error.message.includes("'text/html' is not a valid JavaScript MIME type") ||
    error.message.includes('Unable to preload CSS for')
  if (isChunkError) {
    console.log('New version detected, reloading the page...')
    window.location.href = to.fullPath
  }
})

useI18nLoader(router)
export default router
